export const jobTypeList = [
  {
    label: "Fixed-Term",
    value: "fixed_term",
    className: "bg-[#F2F5FF] text-[#4A72FF]",
  },
  {
    label: "Hourly",
    value: "hourly",
    className: "bg-[#1DB4691F] text-[#11A75C]",
  },
  {
    label: "Bids",
    value: "open_bid",
    className: "bg-[#FFF6ED] text-[#FC8415]",
  },
  // {
  //   label: "Milestone",
  //   value: "milestone",
  //   className: "bg-[#F2F5FF] text-[#636DD3]",
  // },
];

export const jobStatusList = [
  {
    label: "Posted",
    value: "posted",
    className: "bg-[#F2F5FF] text-[#4A72FF]",
  },
  // {
  //   label: "Interviewing",
  //   value: "interviewing",
  //   className: "bg-[#FFF9DF] text-[#D8A800]",
  // },
  {
    label: "Hired",
    value: "hired",
    className: "bg-[#1DB4691F] text-[#11A75C]",
  },
  {
    label: "Deleted",
    value: "deleted",
    className: "bg-[#FFF5F4] text-[#FF3838]",
  },
  {
    label: "Closed",
    value: "closed",
    className: "bg-[#FFF5F4] text-[#FF3838]",
  },
];
